import {Injectable} from '@angular/core';
import {environment} from '../../environments/environment';
import * as utente from '../_interfaces/IUtente';
import {Router} from '@angular/router';

@Injectable()
export class CheckPermessoService {
  apiUrl: string = environment.apiUrl;
  user: utente.IUtente;
  moduli: Array<any>;
  prove: number;

  constructor(private router: Router) {
    this.prove = 0;

    this.riprova();
  }

  public check(permesso) {
    let ret = false;

    if (this.user) {
      if (this.user.admin === 1) {
        ret = true;
      } else {
        if (this.user.ruolo.moduli) {
          // check modulo
          for (let i = 0, len = this.user.ruolo.moduli.length; i < len; i++) {
            if (this.user.ruolo.moduli[i].modulo.key === permesso && this.moduli[i].isAttivo) {
              ret = true;
              break;
            }
          }
        } else {
          ret = false;
        }
      }
    }

    return ret;
  }

  riprova() {
    this.prove++;
    if (this.prove < 5) {
      if (localStorage.getItem('userPayload')) {
        try {
          let payload: utente.IUtente = utente.INITIAL_IUTENTE;
          payload = JSON.parse(localStorage.getItem('userPayload'));
          this.user = payload;
          this.moduli = payload.ruolo ? payload.ruolo.moduli : [];
          this.prove = 0;
        } catch (e) {
          console.log('errore in CheckPermessoService: ');
          console.log(e);

          this.router.navigate(['/login']);
        }
      } else {
        setTimeout(() => {
          this.riprova();
        }, 500);
      }
    } else {
      console.log('errore in riprova CheckPermessoService');
    }
  }
}


